var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.32422 1.89062L8.89539 2.79774L5.47133 8.72838L3.8881 9.65639L3.90016 7.82127L7.32422 1.89062Z","fill":"currentColor"}));
}

Edit.defaultProps = {"viewBox":"0 0 12 12","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
